import React from "react";
import { User } from "@dto/User";
import { Modal, ModalContent, ModalTitle } from "@ui-kit/Modal/Modal";
import { Text } from "@ui-kit/Text/Text";
import { Avatar } from "@ui-kit/Avatar/Avatar";

import "./UserProfile.css";

interface UserProfileProps {
  user: User;
  isOpen: boolean;
  onClose: () => void;
}

const UserProfile = ({ user, isOpen, onClose }: UserProfileProps) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalTitle>Profile</ModalTitle>
      <ModalContent>
        <div className="user-profile-component">
          <Avatar name={user.name} size={56} />
          <div className="user-details">
            <div className="user-name">
              <Text variant="fontHeadingMedium">{user.name}</Text>
            </div>
            {user.email && <Text variant="fontBodyMedium">{user.email}</Text>}
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};

export { UserProfile };
